import { useFormikContext } from 'formik';
import { Label } from '@antimatterhq/ui/components/label';
import Spacer from '@antimatterhq/ui/components/spacer';
import { FiltersSchemaValues } from '@/zod/schemas/dataSource/Common';
import { FormSqlWhereInput } from '@/components/form/sql/where/FormSqlWhereInput';

export type DataSourceFiltersProps = {
  filters: FiltersSchemaValues;
  prefix?: string;
  disabled?: boolean;
};

export const DataSourceFilters = ({
  filters,
  prefix = '',
  disabled = false,
}: DataSourceFiltersProps) => {
  const formik = useFormikContext<FiltersSchemaValues>();

  const { handleChange, handleBlur } = formik;

  const filterName = `${prefix}filter`;
  const postFilterName = `${prefix}postFilter`;

  return (
    <>
      <Label htmlFor={filterName} id={`${filterName}-label`}>
        Pre-processing filter
      </Label>
      <div className="flex gap-2">
        <div className="flex-grow">
          <FormSqlWhereInput
            value={filters.filter || ''}
            onChange={handleChange}
            onBlur={handleBlur}
            name={filterName}
            disabled={disabled}
            aria-labelledby={`${filterName}-label`}
            data-testid="filter-field-input-0"
          />
        </div>
      </div>

      <Spacer size="lg" />

      <Label htmlFor={postFilterName} id={`${postFilterName}-label`}>
        Post filter
      </Label>
      <div className="flex gap-2">
        <div className="flex-grow">
          <FormSqlWhereInput
            value={filters.postFilter || ''}
            onChange={handleChange}
            onBlur={handleBlur}
            name={postFilterName}
            disabled={disabled}
            aria-labelledby={`${postFilterName}-label`}
            data-testid="filter-value-input-0"
          />
        </div>
      </div>
    </>
  );
};
